var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 11H16.5C16.8978 11 17.2794 11.158 17.5607 11.4393C17.842 11.7206 18 12.1022 18 12.5C18 12.8978 17.842 13.2794 17.5607 13.5607C17.2794 13.842 16.8978 14 16.5 14H9C8.60218 14 8.22064 13.842 7.93934 13.5607C7.65804 13.2794 7.5 12.8978 7.5 12.5C7.5 12.1022 7.65804 11.7206 7.93934 11.4393C8.22064 11.158 8.60218 11 9 11ZM19.5 23H27C27.3978 23 27.7794 23.158 28.0607 23.4393C28.342 23.7206 28.5 24.1022 28.5 24.5C28.5 24.8978 28.342 25.2794 28.0607 25.5607C27.7794 25.842 27.3978 26 27 26H19.5C19.1022 26 18.7206 25.842 18.4393 25.5607C18.158 25.2794 18 24.8978 18 24.5C18 24.1022 18.158 23.7206 18.4393 23.4393C18.7206 23.158 19.1022 23 19.5 23ZM9 17H27C27.3978 17 27.7794 17.158 28.0607 17.4393C28.342 17.7206 28.5 18.1022 28.5 18.5C28.5 18.8978 28.342 19.2794 28.0607 19.5607C27.7794 19.842 27.3978 20 27 20H9C8.60218 20 8.22064 19.842 7.93934 19.5607C7.65804 19.2794 7.5 18.8978 7.5 18.5C7.5 18.1022 7.65804 17.7206 7.93934 17.4393C8.22064 17.158 8.60218 17 9 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.4d7044c061dc048394efb6c33e7e92a6.svg";
export { ForwardRef as ReactComponent };